// extracted by mini-css-extract-plugin
export default {"container":"UserNotifs_container__JZ7dd","content":"UserNotifs_content__6JY7K","rotate":"UserNotifs_rotate__Qb4lF"};